import { defineMessages } from 'react-intl';

export default defineMessages({
  quantity: {
    id: 'Pdp.CartConfirmationItem.quantity',
    defaultMessage: 'Qty: {quantity}',
  },
});
